import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Col, Row, Container, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import Segment from '../../components/Segment';
import ActionEdit from '../../components/ActionEdit';
import Action from '../../components/Action';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class SegmentEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            segment: {
                id: parseInt(this.props.match.params.segment_id, 10) || '',
                description: '',
                name: '',
                segment_query: '',
            },
            actions: [],
            isLoading: false,
            isValidating: false,
            segmentUserCount: 0,
            validationError: '',
            isAddNewAction: false,
            isGettingParams: false,
            segmentParams: ''
        };
    }
    componentWillMount() {
        this.getSegment();
    }
    componentDidMount = () => {
        
    }
    getSegment() {
        const { segment } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `segment/${segment.id}`,
            success: (response) => {
                this.setState({
                    segment: response.segment,
                });
                this.setState({ isLoading: false }, this.getSegmentActions);
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    saveSegment() {
        const { segment } = this.state;
        api.fetchAPI({
            method: 'put',
            uri: `segments`,
            body: segment,
            success: (response) => {
                this.setState({
                    segment: response.segment,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    validateQuery() {
        this.setState({ isValidating: true });
        const { segment } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `segment/${segment.id}/validate/query`,
            success: (response) => {
                if (response.status == 'ok') {
                    if (response.segment) {
                        this.setState({
                            segmentUserCount: response.segment.user_count,
                            validationError: '',
                        });
                    }
                } else {
                    this.setState({
                        validationError: response.message,
                    });
                }
                this.setState({ isValidating: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isValidating: false });
            }
        });
    }
    async getSegmentParams() {
        await this.saveSegment();
        this.setState({ isGettingParams: true, segmentParams: null});
        const { segment } = this.state
        api.fetchAPI({
            method: 'get',
            uri: `segment/${segment.id}/get_params/query`,
            success: (response) => {
                if (response.status == 'ok') {
                    if (response.segment) {
                        this.setState({
                            segmentParams: response.segment.available_params,
                            validationError: '',
                        });
                    }
                } else {
                    this.setState({
                        validationError: response.message,
                    });
                }
                this.setState({ isGettingParams: false});
            },
            error: (error) => {
                console.error(error);
                this.setState({ isGettingParams: false});
            }
        });
    }
    getSegmentActions() {
        const { segment } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `actions?segment_id=${segment.id}&order_by=created_at&order_type=descending`,
            success: (response) => {
                this.setState({
                    actions: response.actions,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
                console.error(error);
                this.setState({ isLoading: false });
            }
        });
    }
    updateAttr(attribute, value) {
        const { segment } = this.state;
        segment[attribute] = value;
        this.setState({ segment });
    }
    createNewAction() {
        this.setState({
            isAddNewAction: true,
        })
    }
    render() {
        const {
            segment,
            isAddNewAction,
            actions,
            isGettingParams,
            segmentParams,
            validationError,
        } = this.state;
        console.log(segmentParams)
        return (
            <div className="page-container">
                <h1>#{segment.id}: {segment.name}</h1>
                <p>{segment.description}</p>
                <p>{segment.segment_query}</p>
                <div>
                    <Button
                        color="success"
                        onClick={() => this.createNewAction()}
                    >
                        + Create new action
                    </Button>
                    <Button
                        color="primary"
                        tag={Link}
                        to={`/segment/${segment.id}/edit`}
                    >
                        Edit segment
                    </Button>
                    <Button
                        color="info"
                        onClick={() => this.getSegmentParams()}
                        disabled={isGettingParams}
                    >
                        Get Segment Parameter(s)
                    </Button>
                </div>
                <div className="segment-params">
                    <div>
                        {segmentParams &&
                            <p>
                                Available parameters: {segmentParams.map(t => <span>{t}</span>)
                                                                    .reduce((prev, curr) => [prev, ', ', curr])}
                            </p>
                        }
                    </div>
                    <div>
                        {validationError &&
                            <p className="query-validation-error">Error: {validationError}</p>
                        }
                    </div>
                </div>
                <div className="segment-detail__action-list">
                    <h3>Action lists</h3>
                    {isAddNewAction &&
                        <ActionEdit isAddNew segment={segment} />
                    }
                    {actions && actions.map(action => 
                        <Action key={action.id} action={action} />
                    )}
                </div>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/pages/SegmentDetail/index.js